/***************************************************************************************************
 * Fix globalThis
 ***************************************************************************************************/
if (typeof (window as any).globalThis === 'undefined') {
  (window as any).globalThis = window;
}

if (typeof window.queueMicrotask !== 'function') {
  window.queueMicrotask = function (callback: Function) {
    Promise.resolve()
      .then(() => callback())
      .catch(err => setTimeout(() => { throw err; }, 0));
  };
}

/***************************************************************************************************
 * Polyfills necesarios para WebView Android antiguos (SDK 27 / Chrome 61+)
 ***************************************************************************************************/
import 'globalthis/auto';
import '@formatjs/intl-locale/polyfill';
import 'core-js/es/array';
import 'core-js/es/array-buffer';
import 'core-js/es/data-view';
import 'core-js/es/date';
import 'core-js/es/error'
import 'core-js/es/object';
import 'core-js/es/promise';
import 'core-js/es/string';
import 'core-js/es/weak-map';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/number';
import 'core-js/es/reflect';
import 'core-js/es/regexp';
import 'core-js/es/symbol';
import 'core-js/es/typed-array';
import 'core-js/es/parse-int';
import 'core-js/es/parse-float';
import 'core-js/es/math';
import 'core-js/es/iterator';
import 'core-js/es/string/match-all';
import 'core-js/es/string/replace-all';
import 'core-js/es/string/trim-start';
import 'core-js/es/string/trim-end';
import 'core-js/es/array/flat';
import 'core-js/es/array/flat-map';
import 'core-js/es/array/at';
import 'core-js/es/weak-set';
import 'core-js/es/reflect';
import 'core-js/es/aggregate-error';
import 'zone.js';

import 'whatwg-fetch';

import 'intersection-observer';

import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/es';
